import script from "./ConfirmDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=3598551c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3598551c"]])

export default __exports__